import { Tag, TagType } from "../dtos";
import { BaseEndpoint } from "./BaseEndpoint";
import { Page } from "./domain";

export class TagsEndpoint extends BaseEndpoint("tags") {
  getByType(types: TagType[]): Promise<Page<Tag>> {
    return this.request("", {
      query: { types, page: 0, size: 20 },
    });
  }
}
